import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Location } from '../../models/api/location';

@Component({
  selector: 'location-selector',
  templateUrl: 'location-selector.html'
})
export class LocationSelectorComponent {
  @Input() locations: Location[] = [];
  @Input() selected: Location = null;
  @Input() disabled = false;
  @Output() locationChange = new EventEmitter<Location>();

  selectById(locationId: string | number): void {
    const location = this.locations.find(item => String(item.idlocacion) === String(locationId));
    if (this.disabled || !location) { return; }
    if (!this.selected || String(location.idlocacion) !== String(this.selected.idlocacion)) {
      this.locationChange.emit(location);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/location-selector/location-selector.ts